import { SECTION_TYPE } from '../../constants';
const { PERSONAL_DATA, EMAIL_OTP_VALIDATION, ACCESS_DATA } = SECTION_TYPE;
import StringHelper from 'utilities/stringHelper';

export const createCollapsedSubtitle = (type, userProfile) => {
    if (type === PERSONAL_DATA) {
        const { docNumber, nationalityCountryName, name, lastName, secondLastName, birthDay, birthMonth, birthYear } =
            userProfile;
        const fieldsOrder = [
            nationalityCountryName,
            StringHelper.capitalize(name),
            StringHelper.capitalize(lastName),
            StringHelper.capitalize(secondLastName),
            `${birthDay}/${birthMonth}/${birthYear}`,
            docNumber,
        ];

        return fieldsOrder.filter(field => field).join(' | ');
    }

    if (type === EMAIL_OTP_VALIDATION) {
        return userProfile.email;
    }

    if (type === ACCESS_DATA) {
        const { docNumber } = userProfile;

        return `${docNumber} | ****`;
    }

    return null;
};
